// src/resources/Letters/LetterList.js
import { useEffect } from "react";
import { useRedirect } from "react-admin";

/**
 * This component exists only to redirect users
 * directly to the "Create Letter" page.
 */
export const LetterList = () => {
  const redirect = useRedirect();

  useEffect(() => {
    redirect("create", "letters");
  }, [redirect]);

  return null;
};
